import {
  UPDATE_ESTADO_CONTABLE_REQUEST,
  UPDATE_ESTADO_CONTABLE_SUCCESS,
  UPDATE_ESTADO_CONTABLE_FAILURE,
  UPDATE_ESTADO_CONTABLE_RESET,
} from "redux/types/estadoContableTypes";

const initialState = {
  actualizar: {
    loading: false,
    data: null,
    error: null,
  },
};

const estadoContableReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ESTADO_CONTABLE_REQUEST:
      return {
        ...state,
        actualizar: {
          ...state.actualizar,
          loading: true,
          error: null,
        },
      };

    case UPDATE_ESTADO_CONTABLE_SUCCESS:
      return {
        ...state,
        actualizar: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case UPDATE_ESTADO_CONTABLE_FAILURE:
      return {
        ...state,
        actualizar: {
          ...state.actualizar,
          loading: false,
          error: action.payload,
        },
      };

    case UPDATE_ESTADO_CONTABLE_RESET:
      return {
        ...state,
        actualizar: initialState.actualizar,
      };

    default:
      return state;
  }
};

export default estadoContableReducer;
